<template>
  <el-tabs
    v-model="jobActiveTab"
    stretch
    style="border: 2px solid #ebeef5; width: 100%; min-height: 65vh"
    @tab-click="tabClicked"
    type="card"
    ref="logsTab"
  >
    <el-tab-pane label="Details" name="Details" lazy>
      <div v-if="activeRecord.type === 'Job'">
        <el-card
          shadow="never"
          style="margin: 0 5px 0 5px"
          class="card"
          v-if="itemsToShow.length > 0"
        >
          <div slot="header">
            <i class="el-icon-d-arrow-right" style="padding-right: 5px" />Run
            Information
          </div>
          Package Name: <b>{{ activeRecord.jobName }}</b
          ><br />
          Result: <b>{{ activeRecord.result }}</b
          ><br />
          Started At: <b>{{ activeRecord.createdAt }}</b
          ><br />
          Duration: <b>{{ activeRecord.duration }}</b
          ><br />
          Run By: <b>{{ activeRecord.runBy }}</b
          ><br />
        </el-card>
      </div>
      <div v-else>
        <el-card
          shadow="never"
          style="margin: 0 5px 0 5px"
          class="card"
          v-if="itemsToShow.length > 0"
        >
          <div slot="header">
            <i class="el-icon-d-arrow-right" style="padding-right: 5px" />Run
            Information
          </div>
          {{ activeRecord.type }} Name: <b>{{ activeRecord.name }}</b
          ><br />
          Result: <b>{{ activeRecord.result }}</b
          ><br />
        </el-card>
        <div v-if="activeRecord.type === 'Process'">
          <el-card
            shadow="never"
            style="margin: 5px 5px 0 5px"
            class="card"
            v-if="itemsToShow.length > 0"
          >
            <div slot="header">
              <i
                class="el-icon-d-arrow-right"
                style="padding-right: 5px"
              />Process Information
            </div>
            Source: <b>{{ activeRecord.processSource }}</b
            ><br />
            <el-table
              :data="activeRecord.processParameters"
              :border="true"
              size="mini"
              style="margin-top: 10px"
            >
              <el-table-column prop="Prompt" label="Parameter Prompt" />
              <el-table-column prop="Value" label="Parameter Value"
            /></el-table>
          </el-card>
        </div>
        <div v-if="activeRecord.type === 'Task'">
          <el-card
            shadow="never"
            style="margin: 5px 5px 0 5px"
            class="card"
            v-if="itemsToShow.length > 0"
          >
            <div slot="header">
              <i
                class="el-icon-d-arrow-right"
                style="padding-right: 5px"
              />General Task Information
            </div>
            Type: <b>{{ activeRecord.taskHistory.type }}</b
            ><br />
            Multiplication Factor: <b>{{ activeRecord.taskHistory.factor }}</b
            ><br />
          </el-card>
          <el-card
            shadow="never"
            style="margin: 5px 5px 0 5px"
            class="card"
            v-if="itemsToShow.length > 0"
          >
            <div slot="header">
              <i
                class="el-icon-d-arrow-right"
                style="padding-right: 5px"
              />Source:
              {{ activeRecord.taskHistory.source }}
            </div>
            <div
              v-if="
                historyDetails.source &&
                activeRecord.taskHistory.source === 'Single Cube' &&
                Array.isArray(historyDetails.source) == false
              "
            >
              Cube Name:
              <b>{{
                historyDetails.source &&
                historyDetails.source.taskHistoryCube.name
              }}</b
              ><br />
              <div
                v-for="(dim, index) in historyDetails.source.taskHistoryDims"
                :key="dim.name"
              >
                <br />
                Dimension Name:
                <b>{{
                  historyDetails.source &&
                  historyDetails.source.taskHistoryDims[index].name
                }}</b
                ><br />
                Element Selected:
                <b>{{
                  historyDetails.source &&
                  historyDetails.source.taskHistoryDims[index].selection
                }}</b
                ><br />
                Element Type:
                <b>{{
                  historyDetails.source &&
                  historyDetails.source.taskHistoryDims[index].selectionType
                }}</b
                ><br />
                Alias Selected:
                <b>{{
                  historyDetails.source &&
                  historyDetails.source.taskHistoryDims[index].selectionAlias
                }}</b
                ><br />
              </div>
            </div>
            <div
              v-if="
                activeRecord.taskHistory.source === 'Multiple Cubes' &&
                Array.isArray(historyDetails.source) == true
              "
            >
              <div
                v-for="(dim, index) in historyDetails.source"
                :key="dim.name"
              >
                <br v-if="index > 0" />
                Dimension Name:
                <b>{{
                  historyDetails.source && historyDetails.source[index].name
                }}</b
                ><br />
                Element Selected:
                <b>{{
                  historyDetails.source &&
                  historyDetails.source[index].selection
                }}</b
                ><br />
                Element Type:
                <b>{{
                  historyDetails.source &&
                  historyDetails.source[index].selectionType
                }}</b
                ><br />
                Alias Selected:
                <b>{{
                  historyDetails.source &&
                  historyDetails.source[index].selectionAlias
                }}</b
                ><br />
              </div>
            </div>
            <div v-if="activeRecord.taskHistory.source === 'Value'">
              Value: <b>{{ activeRecord.taskHistory.value }}</b>
            </div>
          </el-card>
          <el-card
            shadow="never"
            style="margin: 5px 5px 0 5px"
            class="card"
            v-if="itemsToShow.length > 0"
          >
            <div slot="header">
              <i
                class="el-icon-d-arrow-right"
                style="padding-right: 5px"
              />Target:
              {{ activeRecord.taskHistory.target }}
            </div>
            <div
              v-if="
                historyDetails.target &&
                activeRecord.taskHistory.target &&
                activeRecord.taskHistory.target.endsWith('Cube') &&
                Array.isArray(historyDetails.target.taskHistoryCube) == false
              "
            >
              Cube Name:
              <b>{{
                historyDetails.target &&
                historyDetails.target.taskHistoryCube &&
                historyDetails.target.taskHistoryCube.name
              }}</b
              ><br />
              <div
                v-for="(dim, index) in historyDetails.target.taskHistoryDims"
                :key="dim.name"
              >
                <br />
                Dimension Name:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].name
                }}</b
                ><br />
                Element Selected:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].selection
                }}</b
                ><br />
                Element Type:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].selectionType
                }}</b
                ><br />
                Alias Selected:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].selectionAlias
                }}</b
                ><br />
              </div>
            </div>
            <div
              v-if="
                historyDetails.target &&
                activeRecord.taskHistory.target &&
                activeRecord.taskHistory.target.endsWith('Cube') &&
                Array.isArray(historyDetails.target.taskHistoryCube) == true
              "
            >
              Cube Name:
              <b>{{
                historyDetails.target &&
                historyDetails.target.taskHistoryCube[0].name
              }}</b
              ><br />
              <div
                v-for="(dim, index) in historyDetails.target.taskHistoryDims"
                :key="dim.name"
              >
                <br />
                Dimension Name:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].name
                }}</b
                ><br />
                Element Selected:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].selection
                }}</b
                ><br />
                Element Type:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].selectionType
                }}</b
                ><br />
                Alias Selected:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target.taskHistoryDims[index].selectionAlias
                }}</b
                ><br />
              </div>
            </div>
            <div v-if="activeRecord.taskHistory.target === 'Multiple Cubes'">
              <div
                v-for="(dim, index) in historyDetails.target"
                :key="dim.name"
              >
                <br v-if="index > 0" />
                Dimension Name:
                <b>{{
                  historyDetails.target && historyDetails.target[index].name
                }}</b
                ><br />
                Element Selected:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target[index].selection
                }}</b
                ><br />
                Element Type:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target[index].selectionType
                }}</b
                ><br />
                Alias Selected:
                <b>{{
                  historyDetails.target &&
                  historyDetails.target[index].selectionAlias
                }}</b
                ><br />
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="Log" name="Log" lazy
      ><el-table :data="logData">
        <el-table-column prop="createdAt" label="Timestamp" :min-width="25" />
        <el-table-column prop="message" label="Message" :min-width="60" />
        <el-table-column
          :min-width="15"
          v-if="logData.includes((record) => record.processErrorLogId)"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.hasErrorFile"
              type="text"
              @click="
                setShowModal();
                recordSelected = scope.row;
              "
              >Error Log</el-button
            >
          </template></el-table-column
        >
      </el-table></el-tab-pane
    >
  </el-tabs>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    showModal: Boolean,
    historyDetails: Object,
    itemsToShow: Array,
    activeTab: String,
    activeRecord: Object,

    logData: Array,
  },
  data() {
    return {
      jobActiveTab: this.activeTab,

      //hi igh
      //logData: [],
      timezone:
        process.env.VUE_APP_SERVER_TIMEZONE ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  },
  computed: {
    ...mapState([
      "currentTaskName",
      "instanceId",
      "taskId",
      "isUserLoggedIn",
      "environmentId",
    ]),
  },
  methods: {
    tabClicked(tab) {
      this.$emit("tabClicked", tab);
    },
    setShowModal() {
      this.$emit("setShowModal");
    },
    debug() {
      console.log(this.activeRecord);
    },
  },
};
</script>
<style scoped>
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
</style>